import { AppContextAccessor } from "services/appContext/AppContextAccessor";

export const getUserSpId = () => {
    const appContext = AppContextAccessor.getAppContext();
    
    return appContext.localStorageInfo.selectedProfile
    ? appContext.localStorageInfo.selectedProfile.spId
    : "";
};